import {ProgressBar} from 'primereact/progressbar';

export const AppProgressBar = () => {
  return (
    <div className="app-progress-bar">
      <ProgressBar mode="indeterminate" style={{height: '6px'}}/>
    </div>
  );
}
